<template>
    <q-list no-border class="menu-list">
        <q-list-header class="q-pr-lg text-center q-my-xs menu-header">
            <router-link to="/"><img src="../../img/identity/logo.png" width="90%"/></router-link>
        </q-list-header>

        <q-item  link item exact class="big" :to="{name: 'home'}">
            Home
        </q-item>
      <q-item v-for="menu in menus" :key="menu.name"
              link item exact class="big" :to="(menu.slug !== '/alertas' ? '/noticias/' : '') + menu.slug">
        {{ $T(menu.name) }}
      </q-item>

        <q-item-separator/>

        <q-item item>
            <div class="row full-width items-baseline">
                <div class="col">
                    <q-input v-model="query" :placeholder="$T('search')"
                    @keydown.enter.prevent="search"/>
                </div>
                <div class="col-auto">
                    <q-btn icon="search" color="primary" class="super-hover on-right"
                           @click.prevent="search"></q-btn>
                </div>
            </div>
        </q-item>

        <q-item-separator/>
        <!--
        Esses dois primeiros ai embaixo deveriam ser dinâmicos tb. Um "submenu"
        O "minha conta" deve verificar se já está logado v-if.
        Assim como o login/esqueci a senha, logout
        -->
        <!-- <q-item link :to="{name: 'alerts.index'}">{{ $T('alerts') }}</q-item> -->
        <q-item link :to="{name: 'contact-us'}">{{ $T('contact us') }}</q-item>
        <q-item link :to="{name: 'tec'}">{{ $T('terms ans conditions') }}</q-item>
        <q-item link to="/profile">{{ $T('my account') }}</q-item>

        <q-item-separator/>
        <q-item>
            <div class="col" v-if="user">
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to news portal!') }}</h6>
                {{ $T('close your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md"
                       :label="$T('log out')" link @click.native="logout"></q-btn>
            </div>

            <div class="col" v-else>
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to news portal!') }}</h6>
                {{ $T('start your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md" :disable="isDiscontinuedActive"
                       :label="$T('log in')" @click.prevent="$login()"></q-btn>
            </div>
        </q-item>
        <q-item>
            <div class="col text-center"><small>© Pocket4Fun - V{{ getVersion() }}</small></div>
        </q-item>
    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'

    import {
        QList,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QField,
        QInput
    } from 'quasar-framework'

    export default {
        components: {
            QList,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QField,
            QInput
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',

            }),

            menus: {
                get() {
                    if(this.$store.state.categories.user_categories.length<=0)
                        this.$store.dispatch("categories/fetchCategories")
                    return this.$store.state.categories.user_categories

                },
                set(value) {

                    this.$store.dispatch('categories/updateCategories', {user_categories: value})
                }
            },

            isDiscontinuedActive () {
                const hoje = new Date(window.config.serverTime)
                const dataLimite = new Date(window.config.dataLimite)
                return hoje >= dataLimite
            }
        },

        data() {
            return {
                query: '',
                appUrl: window.config.appUrl
            }
        },

        methods: {
            async logout() {
                // Log out the user.
                this.$router.push("/")

                await this.$store.dispatch('auth/logout')
                window.location.href = '/logout'

                // Redirect to login.
            },
            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', {locale})
                }
            },
            search() {
                this.$router.push({ name: 'article.search', params: {query: this.query} })
            },
            getVersion() {
                return config.appVersion;
            },
            redirect(slug) {
                window.location.href = slug
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue